import { TopNavigation } from '@amzn/awsui-components-console';
import { Auth } from 'aws-amplify';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { languageSelectionTranslations, supportedLocales } from '@/i18n';
import { paths } from '@/routing/paths';
import { useUserInfo, copyToClipboard } from '@/utils';
import { useLocale } from '@/utils/locale';

import messages from './index.messages';
import logo from './logo.png';

export const NAV_BAR_SELECTOR = 'top-navigation';

const NavBar = () => {
    const { formatMessage } = useIntl();
    const { locale, localeSet } = useLocale();
    const navigate = useNavigate();
    const { email, userKey } = useUserInfo();

    const localeOptions = useMemo(
        () =>
            supportedLocales.reduce(
                (accumulator, current) => [
                    ...accumulator,
                    {
                        text: languageSelectionTranslations[current],
                        id: current,
                        disabled: current === locale,
                        lang: current,
                    },
                ],
                [],
            ),
        [locale],
    );

    const onMenuItemClick = (event) => {
        switch (event.detail.id) {
            case 'signout':
                Auth.signOut();
                break;
            case 'accountId':
                // TODO: add feedback for successful copy
                copyToClipboard({ value: userKey });
                break;
            case 'providers':
                navigate(paths.providersPage);
                break;
            default:
                break;
        }
    };

    const onLanguageChange = (e) => {
        localeSet(e.detail.id);
    };

    const utilities = [
        {
            type: 'menu-dropdown',
            text: languageSelectionTranslations[locale],
            iconName: 'settings',
            onItemClick: onLanguageChange,
            items: localeOptions,
        },
        {
            type: 'menu-dropdown',
            text: formatMessage(messages.accountDropdown),
            iconName: 'user-profile',
            onItemClick: onMenuItemClick,
            items: [
                {
                    id: 'email',
                    text: formatMessage(messages.emailDisplay, { email }),
                    disabled: true,
                },
                {
                    id: 'accountId',
                    text: formatMessage(messages.accountIdDisplay, { userKey }),
                    iconName: 'copy',
                    iconAlt: formatMessage(messages.copyAccountId),
                },
                { id: 'providers', text: formatMessage(messages.changeProvider) },
                { id: 'signout', text: formatMessage(messages.signout) },
            ],
        },
    ];

    return (
        <div style={{ position: 'sticky', top: 0, zIndex: 1002 }} data-testid='nav-bar'>
            <TopNavigation
                data-id={NAV_BAR_SELECTOR}
                identity={{
                    href: paths.root,
                    logo: {
                        src: logo,
                        alt: formatMessage(messages.awsTAndC),
                    },
                }}
                utilities={utilities}
            />
        </div>
    );
};

export default NavBar;
